import internalAbstract from './js/internal-abstract';
import assignement from './js/assignment';
import session from './js/session';
import './css/common.scss';

export default function() {
    internalAbstract();
    assignement();
    session();
}
